import React from 'react';
import { CTAButton } from './CTAButton';
export function CTASection() {
  return <section className="py-16 bg-warm-900 text-center relative overflow-hidden" data-id="element-5">
      {/* Decorative circles */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-rose-500 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-blob" data-id="element-6"></div>
      <div className="absolute bottom-0 right-0 w-64 h-64 bg-rose-300 rounded-full mix-blend-multiply filter blur-3xl opacity-10 animate-blob animation-delay-2000" data-id="element-7"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-8">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 font-serif" data-id="element-9">
          Nadie va a venir a rescatar tus finanzas...
        </h2>
        <p className="text-xl text-rose-100 mb-10 max-w-2xl mx-auto" data-id="element-10">
          Pero tampoco tienes que hacerlo sola. La diferencia entre seguir
          apretada y tener un ingreso extra es una decisión.
        </p>

        <div className="flex flex-col items-center gap-6" data-id="element-11">
          <CTAButton onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-12">
            Quiero mi primer ingreso extra
          </CTAButton>

          <p className="text-warm-400 text-sm max-w-md" data-id="element-13">
            En unos días podrás decir: "Ya tengo mi primer plan de chamba
            digital… y voy por mi primer pago."
          </p>
        </div>
      </div>
    </section>;
}